export default "__VITE_ASSET__fnjyvfdj__"